import { render, staticRenderFns } from "./study.vue?vue&type=template&id=bb15f3ca&scoped=true"
import script from "./study.vue?vue&type=script&lang=js"
export * from "./study.vue?vue&type=script&lang=js"
import style0 from "./study.vue?vue&type=style&index=0&id=bb15f3ca&prod&lang=scss&scoped=true"
import style1 from "./study.vue?vue&type=style&index=1&id=bb15f3ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb15f3ca",
  null
  
)

export default component.exports